"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";

/**
 * The hero for a post with no picture: a stage light falling on the category's
 * name, lit in the category's colour.
 *
 * Showcase gives the hero 66% of a 1060px card, and an empty panel there reads
 * as a broken image. Collapsing to one column instead would make a picture-less
 * spotlight a different shape from every other one, so the cover keeps the
 * shape and spends the space on the one thing the post does have: what it is
 * about. Same 1200:630 frame as a feature image, so nothing below it moves;
 * in the Showcase's 5:4 hero area it fills the area instead.
 */
export function SpotlightCoverHero(t0) {
  const $ = _c(14);
  const {
    label,
    color,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative isolate aspect-1200/630 w-full overflow-hidden bg-[#0b1230]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `radial-gradient(90% 70% at 50% 108%, ${color}cc 0%, ${color}33 42%, transparent 70%), radial-gradient(60% 50% at 88% 0%, ${color}55 0%, transparent 70%)`;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      backgroundImage: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${label}, new on Cova`;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div aria-hidden={true} className="absolute left-1/2 top-0 -z-10 h-[150%] w-[160%] -translate-x-1/2" style={{
      backgroundImage: "conic-gradient(from 180deg at 50% 0%, transparent 162deg, rgba(255,255,255,0.10) 172deg, rgba(255,255,255,0.20) 180deg, rgba(255,255,255,0.10) 188deg, transparent 198deg)"
    }} />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div aria-hidden={true} className="absolute inset-0 -z-10 opacity-60" style={{
      backgroundImage: "radial-gradient(rgba(255,255,255,0.14) 1px, transparent 1px)",
      backgroundSize: "18px 18px",
      maskImage: "radial-gradient(70% 60% at 50% 70%, black, transparent)"
    }} />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/60">New on Cova</span>;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== label) {
    t8 = <div className="absolute inset-x-0 bottom-[18%] flex flex-col items-center gap-2 px-6 text-center">{t7}<span className="text-balance text-[clamp(28px,4.2vw,46px)] font-semibold leading-none tracking-[-0.035em] text-white">{label}</span></div>;
    $[7] = label;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4 || $[12] !== t8) {
    t9 = <div className={t1} style={t3} role="img" aria-label={t4}>{t5}{t6}{t8}</div>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}